export default "__VITE_ASSET__KCOeDm5___"